import {t} from 'i18next';
import AurDialog, {DialogProps} from '../../common/aur-dialog/AurDialog';
import {ReactComponent as InfoAlertIcon} from '../../../assests/svg/warning-blue-icon.svg';
import {Typography} from '@mui/material';

interface RGFWarningPopupAlertProps {
  disabledRGFLabelArray: string[];
  shouldAppendUpdateRGFMsg?: boolean;
  showDialog: DialogProps['showDialog'];
  onOk: DialogProps['onOk'];
  onCancel: DialogProps['onCancel']
}
const RGFWarningPopupAlert = ({
  disabledRGFLabelArray,
  shouldAppendUpdateRGFMsg = false,
  showDialog,
  onOk,
  onCancel
}: RGFWarningPopupAlertProps) => {
  const renderContent = () => {
    return (
      <Typography className="typo-text body2_size">
        {`${t('indexSearchPage.queryRGFWarningPopup.dialogContentRunning')} ${shouldAppendUpdateRGFMsg ? t('indexSearchPage.queryRGFWarningPopup.dialogContentUpdate') : ''}`}
      </Typography>
    );
  };

  return (
    <AurDialog
      buttonStyle={'single'}
      showDialog={showDialog}
      className={'clear-confim-alert-cancel-dialog query-warning-popup'}
      popupTitle={`${disabledRGFLabelArray.join(', ')} ${disabledRGFLabelArray.length > 1 ? t('indexSearchPage.queryRGFWarningPopup.noLongerGroups') : t('indexSearchPage.queryRGFWarningPopup.noLongerGroup')}`}
      type="alert"
      dialogTitle={t('indexSearchPage.queryRGFWarningPopup.dialogTitle')}
      infoIcon={
        <div className="delete-confirm-alert-icon mt-5">
          <InfoAlertIcon />
        </div>
      }
      popupContent={renderContent()}
      labelActionOk={t('indexSearchPage.queryRGFWarningPopup.buttonOK')}
      onOk={onOk}
      onCancel={onCancel}
    />
  );
};

export default RGFWarningPopupAlert;
